import React, { useCallback, useEffect, useState } from "react";
import { addNotification as notify } from "reapop";
import { connect } from "react-redux";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.min.css";
import "jquery-ui-dist/jquery-ui.min.js";
import "./Styles.css";
import AdminConfirmationModal from "../adminConfirmationModal";
import { api_v2 } from "../../NewIndex.api";
import {
  parseTable,
  validateTemperatureEmpty,
  validateTempMessageEmpty,
  validateTemperatureSymbolOrder,
  validateTemperatureValue,
  validateTemperatureRange,
  validateDuplicateEntries,
  validateTimeAnydurationCheck,
  validateTimeSymbolCheck,
  validateTimeHRSCheck,
  validateTempMessageInvalid,
} from "./TETRuleValidation";
import ErrorModal from "./errorModal";
import { REF_DATA } from "../../../constants";
import { getApplicationRegex } from "../../plugins/utils";

const TETRulesDraft = (props) => {
  const [lowLimit, setLowLimit] = useState("");
  const [upLimit, setUpLimit] = useState("");
  const [rows, setRows] = useState([]);
  const [reorderedRows, setReorderedRows] = useState([]);

  const [actionType, setActionType] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [aboveAndBelowText, setAboveAndBelowText] = useState("");
  const [errorMessageTemp, setErrorMessageTemp] = useState("");
  const [errorMessageText, setErrorMessageText] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showGenericMessage, setShowGenericMessage] = useState(false);
  const [genericMessage, setGenericMessage] = useState("");
  const [genericMessageRequired, setGenericMessageRequired] = useState("");

  const fields = props.TETFields;
  const setActiveTab = props.setActiveTab;

  const [flag, setFlag] = useState(null);
  const addRow = () => {
    const newRow = {
      id: Date.now(),
      tempMinRange: "<",
      tempMin: "",
      tempMaxRange: "<=",
      tempMax: "",
      durationMinRange: "<=",
      durationMaxRange: "<=",
      durationMin: "",
      durationMax: "",
      message: "",
      color: "#FA5B5B",
      isChecked: false,
    };
    // Add the new row to rows
    const updatedRows = [...rows, newRow];
    setRows(updatedRows);

    // Update reorderedRows to include all row IDs to reflect current order
    setReorderedRows(updatedRows.map((row) => row.id));
  };

  const celsiusToFahrenheit = (celsius) => {
    return `Temperature in °F: ${Math.round((celsius * 9) / 5 + 32)}°F`;
  };

  const handleChange = (event, id, field) => {
    const { value } = event.target;
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const handleToggle = (id, field) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id
          ? {
              ...row,
              [field]:
                row[field] && row[field] === "#FA5B5B" ? "#58DE49" : "#FA5B5B",
              isChecked: !row.isChecked,
            }
          : row
      )
    );
  };

  const handleDelete = (id) => {
    // setRows(rows.filter((row) => row.id !== id));
    const updatedRows = rows.filter((row) => row.id !== id);
    setRows(updatedRows);

    // Update reorderedRows to exclude the deleted row
    setReorderedRows(updatedRows.map((row) => row.id));
  };

  const saveTETDraftRule = useCallback(() => {
    const orderedRows =
      reorderedRows.length > 0
        ? reorderedRows.map((id) => rows.find((row) => row.id == id))
        : rows;

    const payload = {
      countryName: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
      productCode: fields.product.value,
      rules: {
        recMinRange: lowLimit,
        recMaxRange: upLimit,
        aboveAndBelowMessage: aboveAndBelowText,
        showGenericMessage: showGenericMessage,
        genericMessage: genericMessage,
        rule: orderedRows,
      },
    };

    api_v2.saveTETDraft(payload, (res) => {
      if (res.ok && res.status === 200) {
        showNotification("Success", "Draft Created Successfully", "success");
      } else {
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
      }
    });
  }, [
    reorderedRows,
    rows,
    lowLimit,
    aboveAndBelowText,
    upLimit,
    fields,
    showGenericMessage,
    genericMessage,
  ]);

  const publishTETDraftRule = useCallback(() => {
    const orderedRows =
      reorderedRows.length > 0
        ? reorderedRows.map((id) => rows.find((row) => row.id == id))
        : rows;

    const payload = {
      countryName: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
      productCode: fields.product.value,
      rules: {
        recMinRange: lowLimit,
        recMaxRange: upLimit,
        aboveAndBelowMessage: aboveAndBelowText,
        showGenericMessage: showGenericMessage,
        genericMessage: genericMessage,
        rule: orderedRows,
      },
    };

    api_v2.publishTETDraft(payload, (res) => {
      if (res.ok && res.status === 200) {
        showNotification("Success", "TET Table is Live Now", "success");
        setActiveTab("liveTETData");
        setShowModal(false);
      } else {
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
      }
    });
  }, [
    reorderedRows,
    rows,
    lowLimit,
    upLimit,
    aboveAndBelowText,
    fields,
    showGenericMessage,
    genericMessage,
  ]);

  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };
  //drag and drop rows
  useEffect(() => {
    if (flag) {
      // Ensure sortable is set only when conditions are appropriate
      $("#tableBody").sortable({
        placeholder: "ui-state-highlight",
        update: function (event, ui) {
          const newOrder = $(this)
            .children("tr")
            .map(function () {
              return $(this).attr("data-id");
            })
            .get();

          setReorderedRows(newOrder);
        },
      });
    }
  }, [flag, rows]);

  useEffect(() => {
    const payload = {
      countryName: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
      productCode: fields.product.value,
    };
    api_v2.fetchTETRule(payload, (res) => {
      if (res.draft !== null) {
        setFlag(true);
        const rulesObject = JSON.parse(res.draft.rules);

        // Set low and up limits
        if (Object.keys(rulesObject).length > 0) {
          setLowLimit(rulesObject.recMinRange);
          setUpLimit(rulesObject.recMaxRange);
          setAboveAndBelowText(rulesObject.aboveAndBelowMessage);
          setShowGenericMessage(
            rulesObject.showGenericMessage === "true" ? true : false
          );
          setGenericMessage(rulesObject.genericMessage);
        }

        // Map the existing rules to rows
        const existingRows = (rulesObject.rule || []).map((rule, index) => ({
          id: Date.now() + index, // Ensure unique ID for each row
          tempMinRange: rule.tempMinRange || "<",
          tempMin: rule.tempMin || "", // Ensure the field name matches
          tempMaxRange: rule.tempMaxRange || "<=",
          tempMax: rule.tempMax || "", // Ensure the field name matches
          durationMinRange: rule.durationMinRange || "<=",
          durationMaxRange: rule.durationMaxRange || "<=",
          durationMin: rule.durationMin || "",
          durationMax: rule.durationMax || "",
          message: rule.message || "",
          color: rule.color || "#FA5B5B", // Default color if not set
          isChecked: rule.color === "#58DE49",
        }));

        setRows(existingRows); // Set the rows with fetched data
        setReorderedRows(existingRows.map((row) => row.id)); // Set reorderedRows
      } else {
        setFlag(false);
      }
    });
  }, [flag]);

  const handleCancel = () => {
    setShowModal(false);
    setActionType(null);
  };

  const clearHighlightedRows = () => {
    const table = document.getElementById("TET_Table");
    const rows = table.getElementsByTagName("tr");
    for (let row of rows) {
      row.style.backgroundColor = "transparent";
    }
  };

  const mainValidateTET = () => {
    if (showGenericMessage) {
      if (validateGenericMessage()) {
        setActionType("publish");
        setShowModal(true);
      }
    } else {
      clearHighlightedRows();
      let tableData = parseTable("TET_Table");

      const ref_Data = props.referenceData.find(function (category) {
        return category.type === REF_DATA;
      }).referenceData;
      const regex = getApplicationRegex(ref_Data);

      if (
        validateLimits() &&
        validateAboveAndBelowText() &&
        validateTemperatureEmpty(
          tableData,
          setShowErrorMessage,
          setErrorMessage
        ) &&
        validateTempMessageEmpty(
          tableData,
          setShowErrorMessage,
          setErrorMessage
        ) &&
        validateTempMessageInvalid(
          tableData,
          setShowErrorMessage,
          setErrorMessage,
          regex
        ) &&
        validateTemperatureSymbolOrder(
          tableData,
          setShowErrorMessage,
          setErrorMessage
        ) &&
        validateTemperatureValue(
          tableData,
          setShowErrorMessage,
          setErrorMessage
        ) &&
        validateTemperatureRange(
          tableData,
          setShowErrorMessage,
          setErrorMessage
        ) &&
        validateDuplicateEntries(
          tableData,
          setShowErrorMessage,
          setErrorMessage
        ) &&
        validateTimeAnydurationCheck(
          tableData,
          setShowErrorMessage,
          setErrorMessage
        ) &&
        validateTimeSymbolCheck(
          tableData,
          setShowErrorMessage,
          setErrorMessage
        ) &&
        validateTimeHRSCheck(tableData, setShowErrorMessage, setErrorMessage)
      ) {
        setActionType("publish");
        setShowModal(true);
      }
    }

    return true;
  };

  const handlePublish = () => {
    mainValidateTET();
  };

  const handleDeleteDraft = () => {
    setActionType("delete");
    setShowModal(true);
  };

  const deleteTETDraftRule = useCallback(() => {
    const payload = {
      countryName: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
      productCode: fields.product.value,
    };
    api_v2.deleteTETDraft(payload, (res) => {
      if (res.ok && res.status === 200) {
        setActiveTab("liveTETData");
        showNotification(
          "Success",
          "Draft Table is deleted successfuly",
          "success"
        );
      } else {
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
      }
    });
    setShowModal(false);
    setActionType(null);
  }, [fields]);

  const validateLimits = () => {
    if (!lowLimit || !upLimit) {
      setErrorMessageTemp(
        "Lower Temperature and Upper Temperature must be present"
      );
      return false;
    }
    setErrorMessageTemp("");
    return true;
  };
  const validateMessage = (message, setErrorMessage) => {
    const ref_Data = props.referenceData.find(function (category) {
      return category.type === REF_DATA;
    }).referenceData;

    const regex = getApplicationRegex(ref_Data);

    if (regex.Emoji_Regex !== null && regex.Script_Regex !== null) {
      if (regex.Emoji_Regex.test(message) || regex.Script_Regex.test(message)) {
        setErrorMessage("Please enter a valid message!");
        return false;
      } else {
        return true;
      }
    } else {
      showNotification(
        "Error!",
        "Validation configuration is missing. Please contact support.",
        "error"
      );
      return true;
    }
  };

  const validateAboveAndBelowText = () => {
    if (!aboveAndBelowText || aboveAndBelowText.trim().length === 0) {
      setErrorMessageText("Message Required");
      return false;
    }
    const isValid = validateMessage(aboveAndBelowText, setErrorMessageText);
    if (isValid) {
      setErrorMessageText(""); // Clears error when validation passes
      return true;
    }
    return false;
  };

  const validateGenericMessage = useCallback(() => {
    if (
      showGenericMessage && genericMessage === null
        ? true
        : genericMessage.trim() === ""
    ) {
      setGenericMessageRequired("Generic message is required");
      return false;
    }
    const isValid = validateMessage(genericMessage, setGenericMessageRequired);
    if (isValid) {
      setGenericMessageRequired(""); // Clears error when validation passes
      return true;
    }
    return false;
  }, [showGenericMessage, genericMessage]);

  return (
    <div>
      {flag ? (
        <div>
          <div className="row">
            <ErrorModal
              isModalOpen={showErrorMessage}
              toggle={() => setShowErrorMessage(false)}
              errorMessage={errorMessage}
            />
            <AdminConfirmationModal
              isModalOpen={showModal}
              toggleYes={
                actionType === "publish"
                  ? publishTETDraftRule
                  : deleteTETDraftRule
              }
              toggleCancel={handleCancel}
              bodyContent={
                actionType === "publish"
                  ? "Are you sure you want to publish?"
                  : "Are you sure you want to delete?"
              }
            />
          </div>
          <div className="mt-3">
            <label className="custom-control custom-checkbox mr-0">
              <input
                type="checkbox"
                className="custom-control-input"
                checked={showGenericMessage}
                onChange={() => {
                  setShowGenericMessage(!showGenericMessage);
                }}
              />
              <span
                id="enableTETProduct"
                className="custom-control-indicator"
              />
              <span
                className="custom-control-description"
                style={{ marginLeft: "3px" }}
              >
                Show Generic Message
              </span>
            </label>
          </div>
          <div className="mt-3">
            {showGenericMessage && (
              <div className="row">
                <div>
                  <b>Generic Message*:</b>
                </div>
                <div style={{ width: "100%" }}>
                  <textarea
                    style={{ width: "100%", height: "100%" }}
                    value={genericMessage}
                    onChange={(e) => {
                      setGenericMessage(e.target.value);
                    }}
                  />
                </div>
              </div>
            )}
            {showGenericMessage && genericMessageRequired && (
              <div style={{ color: "red", marginTop: "10px" }}>
                *{genericMessageRequired}
              </div>
            )}
          </div>
          {!showGenericMessage && (
            <div>
              <div className="row" style={{ marginTop: "15px" }}>
                <div
                  className="col-md-4"
                  style={{
                    marginBottom: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <b>Recommended range From:</b>
                  <input
                    type="text"
                    className="form-control"
                    style={{ width: "50px" }}
                    value={lowLimit}
                    onChange={(e) => setLowLimit(e.target.value)}
                  />
                  <b>°C To:</b>
                  <input
                    type="text"
                    className="form-control"
                    style={{ width: "50px" }}
                    value={upLimit}
                    onChange={(e) => setUpLimit(e.target.value)}
                  />
                  <b>°C</b>
                </div>
                <div
                  className="col-md-12"
                  style={{ color: "red", marginTop: "10px" }}
                >
                  {errorMessageTemp && <span>{errorMessageTemp}</span>}
                </div>
              </div>
              <div className="row" style={{ overflowX: "auto" }}>
                <div
                  className="new-col"
                  style={{ width: "100%", marginLeft: "10px" }}
                >
                  <table className="table table-bordered" id="TET_Table">
                    <thead>
                      <tr>
                        <th style={{ width: "320px" }} colspan="2">
                          Temperature Range in °C
                        </th>

                        <th style={{ width: "340px" }} colspan="2">
                          Duration in Hours
                        </th>
                        <th style={{ minWidth: "424.82px", width: "426px" }}>
                          Message
                        </th>
                        <th>Color</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody id="tableBody">
                      {rows.map((row) => (
                        <tr key={row.id} data-id={row.id}>
                          <td style={{ width: "150px" }}>
                            <div>
                              <select
                                value={row.tempMinRange}
                                onChange={(e) =>
                                  handleChange(e, row.id, "tempMinRange")
                                }
                              >
                                <option value={"<"}>{"<"}</option>
                                <option value={">="}>{">="}</option>
                                <option value={">"}>{">"}</option>
                              </select>
                              <input
                                type="text"
                                value={row.tempMin}
                                onChange={(e) =>
                                  handleChange(e, row.id, "tempMin")
                                }
                              />
                              °C
                            </div>
                            <div
                              style={{ marginTop: "5px", fontWeight: "bold" }}
                            >
                              {row.tempMin
                                ? celsiusToFahrenheit(row.tempMin)
                                : ""}
                            </div>
                          </td>
                          <td style={{ width: "150px" }}>
                            <div>
                              <select disabled>
                                <option value={"<="} selected>
                                  {"<="}
                                </option>
                              </select>
                              <input
                                type="text"
                                value={row.tempMax}
                                onChange={(e) =>
                                  handleChange(e, row.id, "tempMax")
                                }
                              />
                              °C
                            </div>
                            <div
                              style={{ marginTop: "5px", fontWeight: "bold" }}
                            >
                              {row.tempMax
                                ? celsiusToFahrenheit(row.tempMax)
                                : ""}
                            </div>
                          </td>

                          <td style={{ width: "160px" }}>
                            <select
                              value={row.durationMinRange}
                              onChange={(e) =>
                                handleChange(e, row.id, "durationMinRange")
                              }
                            >
                              <option value={"<="}>{"<="}</option>
                              <option value={">"}>{">"}</option>
                            </select>
                            <input
                              type="text"
                              value={row.durationMin}
                              onChange={(e) =>
                                handleChange(e, row.id, "durationMin")
                              }
                            />
                            Hrs
                          </td>
                          <td style={{ width: "160px" }}>
                            <select disabled>
                              <option value={"<="} selected>
                                {"<="}
                              </option>
                            </select>
                            <input
                              type="text"
                              value={row.durationMax}
                              onChange={(e) =>
                                handleChange(e, row.id, "durationMax")
                              }
                            />
                            Hrs
                          </td>
                          <td>
                            <textarea
                              style={{ width: "100%", height: "80px" }}
                              value={row.message}
                              onChange={(e) =>
                                handleChange(e, row.id, "message")
                              }
                            />
                          </td>
                          <td style={{ width: "100px" }}>
                            <label className="switch">
                              <input
                                type="checkbox"
                                // adding a line
                                checked={row.isChecked}
                                onChange={() => handleToggle(row.id, "color")}
                              />
                              <span
                                className="slider"
                                style={{
                                  backgroundColor: row.color,
                                }}
                              ></span>
                            </label>
                          </td>
                          <td style={{ width: "100px" }}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="24"
                              fill="red"
                              class="bi bi-trash"
                              viewBox="0 0 16 16"
                              style={{ cursor: "pointer" }}
                              title="Delete"
                              onClick={() => handleDelete(row.id)}
                            >
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <button className="btn btn-success" onClick={addRow}>
                    Add Row
                  </button>
                </div>
              </div>
              <br />
              <br />
              <div className="row">
                <div style={{ width: "100%", marginLeft: "10px" }}>
                  <div>
                    <b>Above and Below text:</b>
                  </div>
                  <textarea
                    style={{ width: "100%", height: "100%" }}
                    value={aboveAndBelowText}
                    onChange={(e) => setAboveAndBelowText(e.target.value)}
                  />
                </div>
              </div>
              <div className="row">
                <div style={{ color: "red", marginTop: "5px" }}>
                  {errorMessageText && (
                    <span
                      style={{
                        marginLeft: "10px",
                        marginTop: "10px",
                        display: "inline-block",
                        paddingTop: "10px",
                      }}
                    >
                      {errorMessageText}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-8"></div>
            <div className="col-md-4" style={{ textAlign: "right" }}>
              <button
                className="btn btn-lg btn-info btn-rounded save_button"
                style={{ backgroundColor: "#071d49" }}
                // onClick={() => resetState()}
                onClick={handlePublish}
              >
                Publish
              </button>
              <button
                className="btn btn-lg btn-info btn-rounded save_button"
                onClick={saveTETDraftRule}
                // disabled
              >
                Save
              </button>
              <button
                className="btn btn-lg btn-info btn-rounded"
                // onClick={() => resetState()}
                onClick={handleDeleteDraft}
              >
                Delete Draft
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-3">
          <b>No TET Draft Table Present</b>
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    referenceData: state.referenceData,
  };
}

export default connect(mapStateToProps, { notify })(TETRulesDraft);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/TET/V2TETRulesDraft.js